"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.PlusButton = exports.FloatingActionButtons = exports.FloatingButtonNewUser = void 0;
exports.FloatingButton = FloatingButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const colors_1 = require("../../common/colors");
const theme_1 = require("../../helper/theme");
const useDevice_1 = require("../../hooks/useDevice");
const AppText_1 = require("../AppText");
const BigButton_1 = __importDefault(require("../GradientButton/BigButton"));
function FloatingButton({ style, children, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)(BigButton_1.default, { containerStyle: [exports.styles.containerButton], style: [exports.styles.button, style], ...restProps, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: exports.styles.content, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: exports.styles.text, children: children }), (0, jsx_runtime_1.jsx)(native_base_1.Divider, { orientation: "vertical", height: 8, opacity: 0.2 }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faChevronUp, color: "white", size: 20 })] }) }));
}
const FloatingChatButton = ({ onPress, label, children, }) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const { isTabOrDesktopDevice, isPortrait } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPress, activeOpacity: 0.9, style: {
                paddingHorizontal: 5,
                position: "absolute",
                bottom: insets.bottom + (isTabOrDesktopDevice && isPortrait ? 30 : 20),
                right: 5,
                height: isTabOrDesktopDevice && isPortrait ? 50 : 72,
            }, accessible: true, accessibilityLabel: "Start chat", accessibilityHint: "Start conversation with one of character from list", children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: colors_1.Colors.GRADIENT, style: [exports.styles.linearGradient], children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "center", alignItems: "center", children: [label !== "" && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { adjustsFontSizeToFit: true, style: [exports.styles.linearGradientText], children: label })), children, (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMessagePlus, color: colors_1.Colors.white, size: 24 })] }) }) }) }));
};
const FloatingButtonNewUser = ({ onPress, label, children, bottom, right = 5, }) => {
    const { isTabOrDesktopDevice, isPortrait } = (0, useDevice_1.useDevice)();
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    return ((0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPress, 
        // underlayColor="white"
        activeOpacity: 0.9, style: {
            paddingHorizontal: 5,
            position: "absolute",
            bottom: react_native_1.Platform.OS === "android"
                ? insets.bottom + 20
                : bottom
                    ? insets.bottom + bottom
                    : insets.bottom,
            right,
            height: isTabOrDesktopDevice && isPortrait ? 50 : 72,
            ...(react_native_1.Platform.OS === "android" && {
                minWidth: 50,
                height: 50,
                marginBottom: 10,
            }),
        }, accessible: true, accessibilityLabel: "Create character", accessibilityHint: "Create your own character to start talking & sharing", children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: colors_1.Colors.GRADIENT, style: [exports.styles.linearGradient], children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "center", alignItems: "center", children: [label !== "" && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [exports.styles.linearGradientText], children: label })), children, (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUserPlus, size: 26, color: colors_1.Colors.white })] }) }) }));
};
exports.FloatingButtonNewUser = FloatingButtonNewUser;
const FloatingActionButtons = ({ onPressChat, onPressCreate, isButtonShow, maxWidth = 40, showChat = true, position = 'right', }) => {
    const { isTabOrDesktopDevice, isWebDevice, isMobileScreen, isPortrait, deviceWidth, } = (0, useDevice_1.useDevice)();
    const MAX_WIDTH = maxWidth;
    const MIN_WIDTH = 11;
    const buttonRef = (0, react_1.useRef)(null);
    const [expandedButtonWidth, setExpandedButtonWidth] = (0, react_1.useState)();
    const animatedButtonWidth = (0, react_1.useMemo)(() => (new react_native_1.Animated.Value(isTabOrDesktopDevice
        ? (deviceWidth * MIN_WIDTH) / 100
        : (deviceWidth * MAX_WIDTH) / 100)), [isTabOrDesktopDevice]);
    const buttonTranslation = (0, react_1.useRef)(isWebDevice ? undefined : animatedButtonWidth);
    (0, react_1.useEffect)(() => {
        buttonRef.current?.measure((_x, _y, width) => {
            setExpandedButtonWidth(width);
            if (isWebDevice) {
                buttonTranslation.current = new react_native_1.Animated.Value(width);
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (isWebDevice) {
            if (expandedButtonWidth) {
                react_native_1.Animated.timing(buttonTranslation.current, {
                    toValue: isButtonShow ? expandedButtonWidth : 20,
                    duration: 600,
                    useNativeDriver: false,
                }).start();
            }
        }
        else {
            react_native_1.Animated.timing(buttonTranslation.current, {
                toValue: isButtonShow
                    ? isTabOrDesktopDevice
                        ? (deviceWidth * MIN_WIDTH) / 100
                        : (deviceWidth * MAX_WIDTH) / 100
                    : 20,
                duration: 600,
                useNativeDriver: false,
            }).start();
        }
    }, [
        isButtonShow,
        buttonTranslation,
        expandedButtonWidth,
        isTabOrDesktopDevice,
        isPortrait,
        isWebDevice
    ]);
    const linlearGradient = (label, icon, size) => {
        return ((0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: colors_1.Colors.GRADIENT, style: [exports.styles.linearGradient, {
                    maxHeight: isWebDevice ? undefined : 50,
                    paddingVertical: isWebDevice && isButtonShow ? 10 : 16,
                    borderRadius: isWebDevice ? 26 : 25,
                }], children: (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { ref: buttonRef, style: {
                    width: (isWebDevice && !expandedButtonWidth
                        ? undefined
                        : buttonTranslation.current),
                }, children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { justifyContent: "center", alignItems: "center", children: [isButtonShow && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, style: {
                                        fontSize: (0, theme_1.normalize)(isWebDevice ? 16 : 18),
                                        fontWeight: isWebDevice ? '500' : undefined,
                                        lineHeight: isWebDevice ? 32 : 20,
                                        flexShrink: 0,
                                        marginRight: isWebDevice ? undefined : 10,
                                    }, children: label }), isWebDevice && ((0, jsx_runtime_1.jsx)(native_base_1.Divider, { orientation: "vertical", marginX: 2.5, opacity: 0.2 }))] })), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: icon, size: size, color: colors_1.Colors.white })] }) }) }));
    };
    return ((0, jsx_runtime_1.jsx)(native_base_1.HStack, { alignSelf: position === 'right' ? "center" : undefined, justifyContent: (position === 'right' && isWebDevice && !isMobileScreen
            ? 'flex-end'
            : 'unset'), width: position === 'right' && !(isWebDevice && !isMobileScreen)
            ? (deviceWidth * 90) / 100
            : '100%', children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                width: (position === 'right' && !(isWebDevice && !isMobileScreen)
                    ? (deviceWidth * (isWebDevice ? 97.5 : 90)) / 100
                    : 'auto'),
            }, children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { alignSelf: "flex-end", space: "2%", children: [showChat && ((0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPressChat, activeOpacity: 0.9, style: {
                            bottom: react_native_1.Platform.OS === "android"
                                ? 10
                                : isTabOrDesktopDevice
                                    ? 0
                                    : 10,
                            height: 52,
                            overflow: "hidden",
                            marginBottom: 5,
                            maxWidth: "49%",
                        }, accessible: true, accessibilityLabel: "Start new chat", accessibilityHint: "Start talking to new character", children: linlearGradient("Chat", pro_light_svg_icons_1.faMessagePlus, 18) })), (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPressCreate, activeOpacity: 0.9, style: {
                            bottom: isTabOrDesktopDevice ? 0 : 10,
                            height: 52,
                            overflow: "hidden",
                            marginBottom: isWebDevice && position === 'right' ? 32 : 5,
                            marginRight: (isWebDevice && position === 'right'
                                ? isMobileScreen
                                    ? 24
                                    : 32
                                : undefined),
                            maxWidth: isWebDevice ? undefined : "49%",
                            // width: "50%",
                        }, accessible: true, accessibilityLabel: "Create character", accessibilityHint: "Create your own character to start talking & sharing", children: isWebDevice ? (linlearGradient(position === 'right' ? "Create Character" : "Create", pro_regular_svg_icons_1.faPlus, 20)) : (linlearGradient("Create", pro_light_svg_icons_1.faUserPlus, 22)) })] }) }) }));
};
exports.FloatingActionButtons = FloatingActionButtons;
exports.default = FloatingChatButton;
var PlusButton_1 = require("./PlusButton");
Object.defineProperty(exports, "PlusButton", { enumerable: true, get: function () { return __importDefault(PlusButton_1).default; } });
exports.styles = react_native_1.StyleSheet.create({
    linearGradient: {
        display: "flex",
        paddingHorizontal: 16,
        borderRadius: 130,
        justifyContent: "center",
        alignItems: "center",
    },
    linearGradientText: {
        textAlign: "center",
        margin: 0,
        fontSize: (0, theme_1.normalize)(18),
        color: colors_1.Colors.white,
    },
    content: {
        gap: 10,
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerButton: {
        position: 'absolute',
        right: 32,
        bottom: 32,
    },
    button: {
        paddingVertical: 10,
        paddingHorizontal: 16,
    },
    text: {
        color: 'white',
        fontSize: 16,
        fontWeight: '500',
        lineHeight: 32,
    },
    contentPressing: {
        opacity: 0.8,
    },
    containerPressed: {
        transform: [{ scale: 0.95 }],
    },
});
